import * as ActionTypes from './actionTypes';

const initialState = {
  id: null,
  email: null,
  agencyId: null,
  name: 'Admin',
};

export default function messages(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_USER:
      return {
        ...state,
        id: action.id,
        email: action.email,
        agencyId: action.agencyId,
      };
    case ActionTypes.CLEAR_USER:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}
